import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between space-x-4" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, " Book Cabanas, the Main House or the entire Villa ")
], -1)
const _hoisted_4 = { class: "mt-6 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-3" }
const _hoisted_5 = { class: "aspect-[5/3] rounded-lg overflow-hidden bg-gray-100 group-hover:opacity-75" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "mt-4 flex items-center justify-between text-base font-medium text-gray-900 space-x-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "absolute inset-0"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "font-['Poly'] text-lg pt-5 text-gray-600" }, " Top O' Tobago is comprised of a main house and swimming pool at the top of the hill, three cabanas or self contained apartments at different levels along the hill ridge, and numerous gardens and patios, on six acres of tropical vegetation. It is breezy and relaxed. ", -1)

import { roomArray } from "@/lib/rooms";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoomList',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roomArray), (room) => {
          return (_openBlock(), _createElementBlock("div", {
            key: room.type,
            class: "relative group"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: room.imageSrc,
                alt: room.imageAlt,
                class: "object-center object-cover"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", null, [
                _createVNode(_component_RouterLink, {
                  to: room.href
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(room.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128)),
        _hoisted_9
      ])
    ])
  ]))
}
}

})